export default "__VITE_ASSET__56396092__"